import { NeutralButton } from "../../common/Buttons"
import { useState } from "react"
import useStore from "../../../store"
import { tdeAuditAppUrl } from "../../../constants/apiUrl"
import ActionConfirmDrawer from "../../common/ActionConfirmDrawer"

export default function TrailerAuditButton({ location }) {
  const tdeToken = useStore((state) => state.tdeToken)

  const [isOpen, setIsOpen] = useState(false)

  const currentFieldAuditId = location.attributes['current-field-audit-id']
  const unitCount = location.attributes['audit-unit-count']

  const buttonText = () => {
    return currentFieldAuditId ? 'Resume Audit' : 'Start Audit'
  }

  const goToAudit = () => {
    const params = new URLSearchParams({ token: tdeToken ?? '' })
    if (currentFieldAuditId) {
      params.append('field_audit_id', currentFieldAuditId)
    } else {
      params.append('location_id', location.id)
    }
    window.location.href = `${tdeAuditAppUrl}?${params.toString()}`
  }

  const handleButtonClick = () => {
    if (currentFieldAuditId) {
      goToAudit()
    } else {
      setIsOpen(true)
    }
  }

  return (
    <>
      <NeutralButton
        text={buttonText()}
        onClick={handleButtonClick}
      />
      <ActionConfirmDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onCancel={() => setIsOpen(false)}
        onConfirm={goToAudit}
        placement="bottom"
        title={`Audit ${location.attributes['name'] ?? 'Location'}`}
        body={`Start a Trailer Audit for ${unitCount} ${unitCount === 1 ? 'trailer' : 'trailers'}?`}
      />
    </>
  )
}
